import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ProgramState = {
  selectedProgram: {
    id: string | any;
    title: string | any;
    description: string | any;
  } | null;
};

const initialState: ProgramState = {
  selectedProgram: null,
};

const programSlice = createSlice({
  name: "program",
  initialState,
  reducers: {
    setSelectedProgram(
      state,
      action: PayloadAction<ProgramState["selectedProgram"]>,
    ) {
      state.selectedProgram = action.payload;
    },
    clearSelectedProgram(state) {
      state.selectedProgram = null;
    },
  },
});

export const { setSelectedProgram, clearSelectedProgram } =
  programSlice.actions;
export default programSlice.reducer;
